import React, { useEffect, useRef, useState } from 'react';

const reduceMotion = () =>
  typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// A number that glides to its new value when it changes (never on first show) and briefly
// flashes green when it goes up / red when it goes down. Used for the balance and the odds.
export default function AnimatedNumber({ value, format = (n) => String(n), duration = 700, className = '' }) {
  const target = Number(value) || 0;
  const [shown, setShown] = useState(target);
  const [dir, setDir] = useState(null);           // 'up' | 'down' while flashing
  const shownRef = useRef(target);

  useEffect(() => {
    const from = shownRef.current;
    if (from === target) return undefined;
    setDir(target > from ? 'up' : 'down');
    const clear = setTimeout(() => setDir(null), 1000);
    if (reduceMotion()) { shownRef.current = target; setShown(target); return () => clearTimeout(clear); }
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const v = from + (target - from) * (1 - Math.pow(1 - p, 3));
      shownRef.current = v;
      setShown(v);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(raf); clearTimeout(clear); };
  }, [target, duration]);

  return <span className={`anim-num ${dir ? `flash-${dir}` : ''} ${className}`}>{format(shown)}</span>;
}
